module.exports = __webpack_public_path__ + "img/1.c15742f9.jpg";